<script setup lang="ts">
import { SnackbarNotificationType } from '@@/enums'

withDefaults(
  defineProps<{
    shortcut: string[]
    darkMode?: boolean | 'auto'
    notificationType?: SnackbarNotificationType
  }>(),
  {
    darkMode: 'auto',
    notificationType: SnackbarNotificationType.success,
  },
)
</script>

<template>
  <div :class="['ms-2 flex gap-x-1 items-center']">
    <div
      v-for="key in shortcut"
      :key="key"
      :class="[
        {
          'bg-[rgba(17,17,17,0.15)]': darkMode === true,
          'bg-light-text-400': darkMode === false,
          'bg-[rgba(17,17,17,0.15)] dark:bg-light-text-400': darkMode === 'auto',
        },
        {
          // tooltip should be 20px x 20px if it is a single character
          'w-3': key.length === 1,
        },
        'px-1 h-5 rounded-md',
        'flex items-center justify-center',
        'font-semibold text-body-small',
      ]"
    >
      {{ key }}
    </div>
  </div>
</template>
